//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';

//components
import {
  Layout,
  Title,
  TitleH2,
  TitleH3,
  TitleH4,
  Paragraph,
  Link,
  BulltetList,
  Header,
} from '@/components/Typography/Legal';
import { LangSelector } from '@/components/LangSelector';

const SubscriptionAndProfessionalServicesAgreementES = () => {
  return (
    <>
      <Navigation />
      <>
        <Layout>
          <Header>
            <Title>Contrato de Suscripción y Servicios Profesionales</Title>

            <div>
              <LangSelector language="es" />
            </div>
          </Header>
          <Paragraph>
            <i>Última actualización: 21 de Enero de 2026</i>
          </Paragraph>
          <Paragraph>
            Este Contrato de Suscripción y Servicios Profesionales, (el “
            <u>Contrato</u>”), se celebra por y entre la entidad identificada
            como el cliente en el Formulario de Pedido aplicable (“
            <u>Cliente</u>”) y Loadsmart, Inc. (“<u>Loadsmart</u>”). El presente
            Contrato establece los términos y condiciones conforme a los cuales
            el Cliente podrá acceder y utilizar los Servicios proporcionados por
            Loadsmart. El presente Contrato entrará en vigor en la Fecha de
            Entrada en Vigor según se define en el Formulario de Pedido y
            permanecerá vigente de conformidad con las disposiciones
            establecidas en el mismo.
          </Paragraph>
          <div>
            <TitleH2>1. DEFINICIONES</TitleH2>
            <Paragraph>
              <strong>1.1. “Afiliada”</strong> significa, respecto de una parte,
              cualquier entidad que (i) sea controlada por, (ii) controle, o
              (iii) se encuentre bajo control común con dicha parte, en donde el
              término “control” significa la titularidad, directa o indirecta,
              de más del cincuenta por ciento (50%) de las acciones con derecho
              a voto para la elección de consejeros.
            </Paragraph>
            <Paragraph>
              <strong>1.2. “Contrato” </strong>significa el presente Contrato de
              Suscripción y Servicios Profesionales junto con el Formulario de
              Pedido o la Declaración de Trabajo aplicable, celebrado por el
              Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.3. “Usuario Autorizado”</strong> significa un empleado
              del Cliente que ha sido autorizado por el Cliente para acceder y
              utilizar los Servicios de Suscripción.
            </Paragraph>
            <Paragraph>
              <strong>1.4. “Información Confidencial”</strong> significa toda
              información no pública de una parte, incluyendo, de manera
              enunciativa mas no limitativa, toda información técnica, secretos
              industriales, know-how, investigación, ideas o planes de productos
              o servicios, códigos y diseños de software, algoritmos,
              desarrollos, invenciones, solicitudes de patentes, cuadernos de
              laboratorio, procesos, fórmulas, técnicas, máscaras de circuito,
              diseños y planos de ingeniería, información de configuración de
              hardware, acuerdos con terceros, listas de, o información
              relacionada con, empleados y consultores de la Parte Reveladora
              (incluyendo, de manera enunciativa mas no limitativa, los nombres,
              información de contacto, puestos, compensación y experiencia de
              dichos empleados y consultores), listas de, o información
              relacionada con, clientes, listas de precios, metodologías de
              fijación de precios, datos de costos, datos de participación de
              mercado, planes de mercadotecnia, licencias, información
              contractual, planes de negocio, proyecciones financieras,
              información financiera histórica, presupuestos u otra información
              comercial, así como nombres de usuario y contraseñas de los
              Servicios de Suscripción revelados por la Parte Reveladora (ya sea
              de forma oral, escrita, gráfica o en formato legible por máquina)
              a la Parte Receptora, la cual sea designada como confidencial o de
              carácter propietario o que, bajo las circunstancias, una persona
              razonable consideraría como confidencial o de carácter
              propietario.
            </Paragraph>
            <Paragraph>
              <strong>1.5. “Cliente”</strong> msignifica la entidad jurídica
              distinta de Loadsmart identificada en el Formulario de Pedido o la
              Declaración de Trabajo aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.6. “Datos del Cliente” </strong> significa cualquier
              dato que sea proporcionado por el Cliente o sus Usuarios
              Autorizados a Loadsmart durante la prestación de los Servicios,
              incluyendo Datos Personales e Información Personal sobre los
              Usuarios Autorizados, pero excluyendo expresamente cualquier Dato
              de Usuario de Terceros y los Datos de Uso. Los Datos del Cliente
              constituyen Información Confidencial del Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.7. “Entregables”</strong> significa el producto de
              trabajo terminado identificado específicamente como entregable en
              la Declaración de Trabajo o el Formulario de Pedido aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.8. “Documentación”</strong> significa la documentación
              técnica relativa a los Servicios de Suscripción proporcionada por
              Loadsmart al Cliente.
            </Paragraph>
            <Paragraph>
              <strong>1.9. “Fecha de Entrada en Vigor”</strong> significa (a) en
              el caso de los Servicios de Suscripción, la fecha que ocurra
              primero entre: (i) el acceso inicial del Cliente a los Servicios
              de Suscripción aplicables en cualquier modalidad, o (ii) la firma
              por parte del Cliente del Formulario de Pedido aplicable; o (b) en
              el caso de los Servicios Profesionales, la fecha de entrada en
              vigor indicada en la Declaración de Trabajo aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.10. “Reclamación Excluida”</strong> significa las
              responsabilidades derivadas de: (i) negligencia grave, dolo o
              fraude de una parte; (ii) la violación por una parte de la
              legislación aplicable; (iii) el incumplimiento del Cliente de la
              Sección 2.2; (iv) las obligaciones de indemnización del Cliente
              establecidas en la Sección 10.1; o (v) el incumplimiento por una
              parte de las obligaciones de confidencialidad establecidas en la
              Sección 7.1.
            </Paragraph>
            <Paragraph>
              <strong>1.11. “Retroalimentación”</strong> significa cualquier
              sugerencia, idea, concepto, know-how, técnica, comentario o
              pregunta que contenga observaciones sobre los Servicios presentada
              por el Cliente o sus Usuarios Autorizados.
            </Paragraph>
            <Paragraph>
              <strong>1.12. “Honorarios”</strong> significa cualquier monto
              pagado por el Cliente por los Servicios, conforme a lo establecido
              en el Formulario de Pedido o la Declaración de Trabajo aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.13. “Propiedad Intelectual”</strong> significa
              cualesquiera y todas las invenciones, secretos industriales,
              know-how, desarrollos, mejoras, resultados, datos, diseños,
              interfaces visuales, gráficos, compilaciones, información, código
              informático (incluyendo código fuente u objeto), productos,
              software, servicios y cualesquiera otros derechos de propiedad
              intelectual reconocidos en cualquier país o jurisdicción del
              mundo.
            </Paragraph>
            <Paragraph>
              <strong>1.14. “Loadsmart”</strong> significa Loadsmart, Inc. y sus
              subsidiarias de propiedad total y Afiliadas.
            </Paragraph>
            <Paragraph>
              <strong>1.15. “Formulario de Pedido”</strong> significa una orden
              de Servicios de Suscripción en un formato aprobado por Loadsmart,
              la cual incorpora el presente Contrato y sus términos por
              referencia.
            </Paragraph>
            <Paragraph>
              <strong>1.16. “Servicios Profesionales”</strong> significa los
              servicios que serán prestados por Loadsmart conforme se describen
              con mayor detalle en la Declaración de Trabajo o el Formulario de
              Pedido aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.17. “Incidente de Seguridad”</strong> significa la
              adquisición efectivamente no autorizada de los Datos del Cliente,
              Información Personal o Información Confidencial de una parte que
              sea mantenida o almacenada por la otra parte, o el acceso o uso no
              autorizado, real o presunto, de los Servicios de Suscripción.
            </Paragraph>
            <Paragraph>
              <strong>1.18. “Servicios”</strong> significa, de manera conjunta,
              los Servicios de Suscripción y los Servicios Profesionales.
            </Paragraph>
            <Paragraph>
              <strong>1.19. “Software”</strong> significa la plataforma de
              software como servicio (Software-as-a-Service) propiedad de y
              operada por Loadsmart a través de la cual un Usuario Autorizado
              puede acceder a los Servicios de Suscripción.
            </Paragraph>
            <Paragraph>
              <strong>1.20. “Declaración de Trabajo”</strong> significa un
              documento celebrado por ambas partes que detalla los Servicios
              Profesionales que serán prestados por Loadsmart y los Entregables
              correspondientes.
            </Paragraph>
            <Paragraph>
              <strong>1.21. “Servicios de Suscripción”</strong> significa la
              suscripción al Software en línea y alojado proporcionado por
              Loadsmart. El alcance de los Servicios de Suscripción adquiridos
              por el Cliente podrá describirse con mayor detalle en el
              Formulario de Pedido.
            </Paragraph>
            <Paragraph>
              <strong>1.22. “Plazo de Suscripción”</strong> significa el periodo
              comprendido desde la fecha de inicio del servicio hasta la fecha
              de terminación del servicio, conforme se establece en el
              Formulario de Pedido aplicable.
            </Paragraph>
            <Paragraph>
              <strong>1.23. “Usuario de Terceros”</strong> significa un usuario
              que accede a los Servicios de Suscripción que no sea el Cliente ni
              Loadsmart.
            </Paragraph>
            <Paragraph>
              <strong>1.24. “Datos de Uso”</strong> significa cualquier
              información derivada del Software como resultado del uso por parte
              del Cliente de los Servicios de Suscripción, incluyendo, de manera
              enunciativa mas no limitativa, datos, estadísticas, tendencias,
              patrones y otra información similar.
            </Paragraph>
          </div>
          <div>
            <TitleH2>2. SERVICIOS DE SUSCRIPCIÓN</TitleH2>
            <Paragraph>
              <TitleH3>2.1. Servicios de Suscripción.</TitleH3>
              Loadsmart proporcionará los Servicios de Suscripción de
              conformidad con el presente Contrato durante la vigencia del Plazo
              de Suscripción. El Cliente podrá acceder y utilizar los Servicios
              de Suscripción únicamente para sus fines comerciales internos,
              sujeto a los términos del presente Contrato, y dicho acceso y uso
              se limita expresamente a los Usuarios Autorizados del Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>2.2. Restricciones.</TitleH3>
              El Cliente no deberá intentar interferir ni interrumpir los
              Servicios de Suscripción o el Software, ni intentar obtener acceso
              a cualesquiera sistemas o redes que se conecten a los mismos
              (salvo en la medida necesaria para acceder y utilizar los
              Servicios de Suscripción). El Cliente no permitirá el acceso o uso
              de los Servicios de Suscripción por ninguna persona distinta de
              los Usuarios Autorizados. El Cliente no deberá, y se asegurará de
              que sus Usuarios Autorizados no: (a) copien, modifiquen o
              distribuyan cualquier parte de los Servicios de Suscripción o del
              Software; (b) renten, arrenden o proporcionen acceso a los
              Servicios de Suscripción o al Software bajo un esquema de tiempo
              compartido o de oficina de servicios; (c) utilicen los Servicios
              de Suscripción o el Software para proporcionar, o incorporar los
              Servicios de Suscripción o el Software en, cualquier producto o
              servicio proporcionado a un tercero; (d) realicen ingeniería
              inversa, descompilen, desensamblen o de cualquier otra forma
              intenten obtener el código fuente o las API no públicas
              relacionadas con los Servicios de Suscripción o el Software; o (e)
              cedan o transfieran cualquiera de sus derechos conforme al
              presente (salvo que se establezca expresamente lo contrario en el
              mismo).
            </Paragraph>
            <Paragraph>
              <TitleH3>2.3. Uso Aceptable.</TitleH3>
              El Cliente deberá utilizar los Servicios de Suscripción
              exclusivamente para fines autorizados y lícitos, de conformidad
              con las leyes y reglamentos aplicables, los derechos de terceros y
              lo dispuesto en el Formulario de Pedido aplicable. Salvo por los
              Datos del Cliente, el Cliente únicamente podrá utilizar los datos,
              información u otro contenido derivado de los Servicios de
              Suscripción para sus fines comerciales internos, en la medida
              necesaria para hacer uso de los Servicios de Suscripción. El
              Cliente será plenamente responsable por todos los actos u
              omisiones de sus Usuarios Autorizados en relación con los
              Servicios de Suscripción, como si hubieran sido realizados por el
              propio Cliente.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                2.4. Uso Ilegal y No Autorizado de los Servicios de Suscripción.
              </TitleH3>
              Loadsmart podrá suspender o dar por terminado de manera inmediata
              el acceso del Cliente a los Servicios de Suscripción, mediante
              notificación escrita al Cliente, en caso de que (i) Loadsmart
              determine, con base en pruebas razonables, que los Servicios de
              Suscripción están siendo utilizados para actividades fraudulentas
              o delictivas, o en violación de cualquier ley o reglamento
              aplicable o del presente Contrato; o (ii) cuando una autoridad
              gubernamental, judicial o de procuración de justicia así lo
              requiera o instruya a Loadsmart a suspender o dar por terminados
              los Servicios de Suscripción al Cliente. El Cliente es y será el
              único responsable por cualquier uso fraudulento, uso indebido o
              actividad ilegal realizada en o a través de los Servicios de
              Suscripción por parte de sus Usuarios Autorizados.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                2.5. Mantenimiento de Datos y Procedimientos de Respaldo.
              </TitleH3>
              Los Servicios de Suscripción no están destinados a fungir como un
              almacén de datos ni como una solución de respaldo de datos. En
              caso de cualquier pérdida o corrupción de los Datos del Cliente,
              Loadsmart realizará esfuerzos comercialmente razonables para
              restaurar los Datos del Cliente perdidos o dañados a partir del
              respaldo más reciente de dichos Datos del Cliente mantenido por
              Loadsmart. El Cliente reconoce que la restauración total de los
              Datos del Cliente puede no ser posible en todas las circunstancias
              y, en tal caso, Loadsmart no asumirá responsabilidad alguna frente
              al Cliente.
            </Paragraph>
          </div>
          <div>
            <TitleH2>3. SERVICIOS PROFESIONALES</TitleH2>
            <Paragraph>
              <TitleH3>3.1. Declaración de Trabajo.</TitleH3>
              De tiempo en tiempo, el Cliente podrá solicitar que Loadsmart
              preste determinados Servicios Profesionales. Cada contratación de
              Servicios Profesionales se describirá detalladamente en una
              Declaración de Trabajo independiente celebrada por ambas partes,
              la cual incluirá, de manera enunciativa mas no limitativa, los
              Honorarios y gastos, los cronogramas del proyecto, los requisitos
              de personal y recursos, así como los Entregables específicos.
            </Paragraph>
          </div>
          <div>
            <TitleH2>4. OBLIGACIONES DEL CLIENTE</TitleH2>
            <Paragraph>
              <TitleH3>4.1. Cooperación y Asistencia.</TitleH3>
              El Cliente deberá en todo momento: (a) proporcionar a Loadsmart
              cooperación y asistencia de buena fe, así como acceso a aquella
              información y al personal que razonablemente pueda ser requerido
              por Loadsmart para prestar los Servicios de tiempo en tiempo; y
              (b) cumplir oportunamente con todas las demás responsabilidades
              del Cliente establecidas en el presente Contrato.
            </Paragraph>
            <Paragraph>
              <TitleH3>4.2. Apoyo de Mercadotecnia.</TitleH3>
              El Cliente otorga a Loadsmart un derecho no exclusivo, no
              transferible, revocable y limitado para utilizar el nombre, las
              marcas comerciales y los logotipos del Cliente (conjuntamente, las
              <strong>“Marcas del Cliente”</strong>) únicamente con el propósito
              de identificar al Cliente como receptor de los Servicios y de
              conformidad con cualesquiera lineamientos de uso de marcas y
              logotipos que el Cliente proporcione a Loadsmart.
            </Paragraph>
          </div>
          <div>
            <TitleH2>5. HONORARIOS; IMPUESTOS</TitleH2>
            <Paragraph>
              <TitleH3>5.1. Honorarios; Pago Tardío.</TitleH3>
              El Cliente deberá pagar los Honorarios y gastos conforme a lo
              establecido en el Formulario de Pedido y la Declaración de Trabajo
              aplicables. En caso de que el uso por parte del Cliente de los
              Servicios de Suscripción exceda las limitaciones establecidas en
              el Formulario de Pedido aplicable, el Cliente será responsable de
              cualquier monto adicional facturado por Loadsmart como resultado
              de dicho exceso. Una vez concluido el Plazo de Suscripción
              inicial, Loadsmart podrá incrementar los Honorarios por los
              Servicios de Suscripción no más de una vez dentro de un periodo de
              doce (12) meses. El Cliente es responsable de mantener información
              de facturación y contacto completa y exacta, así como de notificar
              a Loadsmart cualquier cambio en dicha información. Todas las
              facturas deberán pagarse dentro de los treinta (30) días
              siguientes a su recepción por parte del Cliente. En caso de que
              una factura no sea pagada oportunamente, Loadsmart tendrá derecho
              a cobrar intereses sobre los montos vencidos a una tasa del uno
              punto cinco por ciento (1.5%) mensual, pero en ningún caso
              superior a la tasa máxima de interés permitida por la ley,
              calculados desde la fecha en que dicho monto haya sido exigible y
              hasta la fecha en que el pago sea recibido por Loadsmart.
              Adicionalmente, si alguna factura presenta un atraso mayor a
              treinta (30) días, Loadsmart podrá: (i) respecto de los Servicios
              de Suscripción, suspender el acceso y uso del Cliente a los
              Servicios de Suscripción sin responsabilidad alguna frente al
              Cliente; o (ii) respecto de los Servicios Profesionales, suspender
              todos los trabajos conforme a la Declaración de Trabajo aplicable.
              En caso de que Loadsmart se vea obligada a iniciar acciones
              legales para el cobro de Honorarios no controvertidos, el Cliente
              estará obligado a reembolsar a Loadsmart los costos razonables de
              cobranza, incluyendo honorarios razonables de abogados. Salvo que
              se establezca lo contrario en la Sección 9.2 y la Sección 10.2,
              todos los Honorarios por los Servicios no serán reembolsables.
            </Paragraph>
            <Paragraph>
              <TitleH3>5.2. Procesamiento de Pagos.</TitleH3>
              El Cliente autoriza a Loadsmart a realizar cargos automáticos a la
              tarjeta de crédito o cuenta bancaria del Cliente por todos los
              Honorarios pagaderos conforme al Formulario de Pedido o la
              Declaración de Trabajo aplicables. El Cliente autoriza asimismo a
              Loadsmart a utilizar a un tercero para el procesamiento de pagos y
              consiente la divulgación de la información de pago del Cliente a
              dicho tercero. El Cliente notificará de inmediato a Loadsmart
              cualquier cambio en la información de facturación de su tarjeta de
              crédito o cuenta bancaria.
            </Paragraph>
            <Paragraph>
              <TitleH3>5.3. Impuestos.</TitleH3>
              Todos los montos y Honorarios establecidos o a los que se haga
              referencia en el presente Contrato o en cualquier Formulario de
              Pedido o Declaración de Trabajo son exclusivos de impuestos,
              derechos, contribuciones, gravámenes, aranceles y demás cargas
              gubernamentales (incluyendo, sin limitación, impuestos sobre
              ventas, uso, GST, IVA, retenciones o impuestos similares)
              (conjuntamente, los <strong>“Impuestos”</strong>). En su caso,
              Loadsmart facturará al Cliente todos los Impuestos como una
              partida separada en cada factura emitida en relación con los
              Servicios.
            </Paragraph>
          </div>
          <div>
            <TitleH2>6. PROPIEDAD INTELECTUAL</TitleH2>
            <Paragraph>
              <TitleH3>6.1. Propiedad Intelectual de Loadsmart.</TitleH3>
              Loadsmart conservará todos los derechos, títulos e intereses sobre
              toda Propiedad Intelectual: (i) de los Servicios de Suscripción;
              (ii) del Software; y (iii) desarrollada por Loadsmart con
              anterioridad al inicio de los Servicios Profesionales, de manera
              independiente a los Servicios Profesionales, y durante la
              prestación de los Servicios Profesionales, siempre que la
              Propiedad Intelectual aplicable no constituya un Entregable; y, en
              cada caso, todos los derechos de Propiedad Intelectual sobre o
              relacionados con los mismos son y permanecerán como propiedad
              única y exclusiva de Loadsmart (conjuntamente, la{' '}
              <strong>“Propiedad Intelectual de Loadsmart”</strong>). Loadsmart
              otorga al Cliente y a sus Usuarios Autorizados una licencia
              limitada, no exclusiva, no sublicenciable, no transferible,
              resoluble y revocable sobre la Propiedad Intelectual de Loadsmart,
              en la medida necesaria para que el Cliente pueda hacer uso de los
              Servicios de Suscripción o del Entregable aplicable para sus fines
              comerciales internos, de conformidad con el Formulario de Pedido o
              la Declaración de Trabajo aplicables.
            </Paragraph>
            <Paragraph>
              <TitleH3>6.2. Propiedad Intelectual del Cliente.</TitleH3>
              El Cliente conservará todos los derechos, títulos e intereses
              sobre toda Propiedad Intelectual: (i) de los Datos del Cliente;
              (ii) cuando sea aplicable y sujeto al pago por parte del Cliente
              de todos los Honorarios y gastos correspondientes, de los
              Entregables; y (iii) de las Marcas del Cliente. Al proporcionar
              Datos del Cliente durante la prestación de los Servicios, el
              Cliente otorga a Loadsmart el derecho y la licencia para usar,
              reproducir, distribuir, modificar y adaptar los Datos del Cliente:
              (x) con el propósito de prestar los Servicios al Cliente,
              incluyendo el derecho de divulgar los Datos del Cliente a los
              empleados, subsidiarias, Afiliadas, contratistas, proveedores y
              Usuarios de Terceros de Loadsmart en la medida necesaria para
              prestar los Servicios al Cliente; y (y) para los fines comerciales
              internos de Loadsmart (sujeto a las obligaciones de
              confidencialidad establecidas en la Sección 7.1).
            </Paragraph>
            <Paragraph>
              <TitleH3>
                6.3. Datos Agregados, de Uso y de Usuarios de Terceros.
              </TitleH3>
              No obstante cualquier disposición en contrario en el presente
              Contrato, Loadsmart podrá utilizar Datos del Cliente
              desidentificados o agregados para cualquier propósito comercial,
              incluyendo, sin limitación, análisis comparativos de la industria,
              orientación sobre mejores prácticas, recomendaciones e informes
              similares que podrán ser distribuidos externamente a otros
              clientes de Loadsmart. Adicionalmente, nada de lo contenido en el
              presente Contrato ni en el Formulario de Pedido o la Declaración
              de Trabajo aplicables restringirá o prohibirá la facultad de
              Loadsmart para utilizar los datos de Usuarios de Terceros o los
              Datos de Uso para cualquier propósito lícito.
            </Paragraph>
            <Paragraph>
              <TitleH3>6.4. Retroalimentación.</TitleH3>
              Loadsmart será libre de utilizar, divulgar, reproducir, licenciar
              o de cualquier otra forma distribuir la Retroalimentación según lo
              considere conveniente, sin obligación o restricción alguna
              derivada de derechos de Propiedad Intelectual o de cualquier otra
              índole; siempre que dicha Retroalimentación no contenga elementos
              específicos o identificables propios del Cliente o de sus
              operaciones. El Cliente no tendrá derecho alguno de Propiedad
              Intelectual sobre los Servicios de Suscripción como resultado de
              la incorporación por parte de Loadsmart de la Retroalimentación en
              los Servicios de Suscripción.
            </Paragraph>
          </div>
          <div>
            <TitleH2>
              7. CONFIDENCIALIDAD; SEGURIDAD; PRIVACIDAD DE DATOS.
            </TitleH2>
            <Paragraph>
              <TitleH3>7.1. Obligaciones de Confidencialidad.</TitleH3> En
              relación con el presente Contrato, una parte podrá revelar (la
              <strong>“Parte Reveladora”</strong>) cierta Información
              Confidencial a la otra parte (la{' '}
              <strong>“Parte Receptora”</strong>). Durante la vigencia del
              presente Contrato y por un periodo de tres (3) años posteriores a
              la expiración o terminación del mismo, la Parte Receptora no
              revelará la Información Confidencial de la Parte Reveladora para
              ningún propósito distinto del ejercicio de sus derechos y el
              cumplimiento de sus obligaciones conforme al presente Contrato. La
              Parte Receptora no divulgará la Información Confidencial a ningún
              tercero, salvo a los empleados, contratistas, proveedores y
              Afiliadas de la Parte Receptora que tengan una necesidad razonable
              de conocer dicha información en relación con el presente Contrato;
              siempre que dichos terceros estén legalmente obligados por
              obligaciones de confidencialidad al menos tan estrictas como las
              establecidas en el presente. La Parte Receptora deberá asegurarse
              de que la Información Confidencial de la Parte Reveladora no sea
              divulgada ni distribuida por sus empleados, contratistas,
              proveedores o Afiliadas en violación a los términos del presente
              Contrato. La Parte Receptora tratará toda la Información
              Confidencial con el mismo grado de cuidado que utiliza para
              proteger su propia Información Confidencial, pero en ningún caso
              con un grado de cuidado inferior al razonablemente exigible.
            </Paragraph>
            <Paragraph>
              Las restricciones de confidencialidad anteriores no serán
              aplicables a aquella información respecto de la cual la Parte
              Receptora pueda demostrar mediante evidencia documental que: (i)
              es o pasa a ser del dominio público sin incumplimiento del
              presente Contrato por parte de la Parte Receptora; (ii) se
              encontraba en posesión de la Parte Receptora antes de haber sido
              recibida de la Parte Reveladora; (iii) fue desarrollada de manera
              independiente por la Parte Receptora sin utilizar ni hacer
              referencia a la Información Confidencial; o (iv) fue recibida
              legítimamente por la Parte Receptora de un tercero con derecho a
              divulgarla ulteriormente.
            </Paragraph>
            <Paragraph>
              No obstante lo anterior, la Información Confidencial podrá ser
              divulgada en la medida en que así lo requiera cualquier autoridad
              gubernamental o proceso judicial; siempre que, antes de
              proporcionar dicha Información Confidencial, la Parte Receptora
              notifique (en la medida en que lo permita la legislación
              aplicable) a la Parte Reveladora con la antelación suficiente para
              permitirle ejercer cualesquiera derechos que pudiera tener para
              impugnar o limitar la divulgación de dicha Información
              Confidencial.
            </Paragraph>
            <Paragraph>
              A solicitud escrita de la Parte Reveladora, la Parte Receptora
              deberá: (i) cesar el uso de la Información Confidencial; (ii)
              devolver la Información Confidencial y todas las copias, notas o
              extractos de la misma a la Parte Reveladora dentro de los siete
              (7) días hábiles siguientes a la recepción de dicha solicitud; y
              (iii) confirmar por escrito que la Parte Receptora ha cumplido con
              las obligaciones establecidas en el presente párrafo. No obstante
              lo anterior, la Parte Receptora podrá conservar una (1) copia de
              la Información Confidencial con el fin de monitorear el
              cumplimiento continuo del presente Contrato y un número limitado
              de copias de respaldo realizadas de conformidad con sus políticas
              estándar de conservación de registros.
            </Paragraph>

            <Paragraph>
              <TitleH3>7.2. Obligaciones de Seguridad.</TitleH3>
              Cada parte deberá: (i) mantener prácticas de seguridad de la
              información comercialmente razonables para sus sistemas utilizados
              para proporcionar o acceder a los Servicios de Suscripción,
              incluyendo procedimientos y prácticas de seguridad adecuados a la
              naturaleza de la información ingresada o almacenada en los
              Servicios de Suscripción y diseñados para prevenir el acceso, uso
              o divulgación no autorizados de cualesquiera Datos del Cliente e
              Información Confidencial o la ocurrencia de un Incidente de
              Seguridad; y (ii) cumplir con todas las leyes y reglamentos de
              privacidad y seguridad de datos aplicables a los Servicios de
              Suscripción. Cada parte notificará oportunamente a la otra parte
              cualquier Incidente de Seguridad. Cuando el Cliente sea la parte
              notificante, la notificación deberá dirigirse a
              Security@Loadsmart.com con copia a Legal@Loadsmart.com. La parte
              notificante investigará razonablemente cualquier Incidente de
              Seguridad de dicha naturaleza. En el caso de Incidentes de
              Seguridad derivados de negligencia grave o dolo de una parte,
              dicha parte será responsable de: (i) los costos de multas
              gubernamentales o regulatorias; y (ii) cuando así lo exija la
              legislación aplicable, de proporcionar notificaciones y/o
              servicios de monitoreo de crédito o protección de identidad a
              cualquier titular de datos afectado por el Incidente de Seguridad
              correspondiente y/o de notificar a cualquier autoridad
              gubernamental, así como de los costos asociados a dichas
              notificaciones o servicios de protección de identidad
              (conjuntamente, los{' '}
              <strong>“Costos por Incumplimiento de Seguridad”</strong>).
              Loadsmart no tendrá responsabilidad alguna de pagar Costos por
              Incumplimiento de Seguridad relacionados con un Incidente de
              Seguridad causado por negligencia, dolo, fraude o violación de la
              legislación aplicable por parte del Cliente o de sus Usuarios
              Autorizados.
            </Paragraph>
            <Paragraph>
              <TitleH3>7.3. Privacidad de Datos</TitleH3>
              El uso y acceso del Cliente a los Servicios, así como el
              tratamiento de los Datos del Cliente por parte de Loadsmart,
              estarán sujetos y se regirán por la política de privacidad de
              Loadsmart, la cual puede consultarse en:{' '}
              <Link href="https://loadsmart.com/privacy-policy">
                https://loadsmart.com/privacy-policy
              </Link>
              , y la cual se incorpora al presente por referencia. Cuando el
              Cliente solicite que Loadsmart participe en el tratamiento de
              “Datos Personales” (según se define en el Reglamento General de
              Protección de Datos de la Unión Europea (“GDPR”)) o “Información
              Personal” (según se define en la Ley de Privacidad del Consumidor
              de California (“CCPA”)) o según se defina en cualesquiera otras
              leyes y reglamentos aplicables, según corresponda, así como en la
              Ley Federal de Protección de Datos Personales en Posesión de los
              Particulares y su reglamento (la <u>“LFPDPPP”</u>), Loadsmart
              actuará como “Responsable” o “Empresa” respecto de los Datos de
              Usuarios de Terceros y como “Encargado” o “Proveedor de Servicios”
              respecto de los Datos del Cliente, respectivamente. Loadsmart
              utiliza y comparte Datos Personales e Información Personal
              conforme a lo establecido en su política de privacidad. Loadsmart
              no “Vende” Información Personal conforme a dicho término se define
              en la CCPA. En caso de que el Cliente elija, en un Formulario de
              Pedido o Declaración de Trabajo, transferir Datos Personales desde
              el Espacio Económico Europeo a Loadsmart en un tercer país, las
              partes celebrarán un Acuerdo de Tratamiento de Datos (“DPA”), el
              cual se incorporará al presente Contrato por referencia. Para los
              fines del presente Contrato, los términos Responsable, Encargado y
              Datos Personales tendrán los significados establecidos en el GDPR,
              y los términos Empresa, Proveedor de Servicios, Información
              Personal y Vender tendrán los significados establecidos en la
              CCPA.
            </Paragraph>
            <Paragraph>
              <TitleH3>7.4.</TitleH3> En caso de cualquier conflicto, el Anexo
              de Protección de Datos – México prevalecerá exclusivamente
              respecto de las materias reguladas por la LFPDPPP.
            </Paragraph>
          </div>
          <div>
            <TitleH2>8. GARANTÍAS Y EXCLUSIONES DE RESPONSABILIDAD</TitleH2>
            <Paragraph>
              <TitleH3>8.1. Declaraciones y Garantías de Loadsmart.</TitleH3>
              Loadsmart declara y garantiza lo siguiente respecto de los
              Servicios:
            </Paragraph>
            <BulltetList>
              <li>
                <Paragraph>
                  <TitleH4>8.1.1.</TitleH4>
                  Loadsmart garantiza que los Servicios de Suscripción se
                  ajustarán sustancialmente a la funcionalidad establecida en la
                  Documentación. En caso de que los Servicios de Suscripción no
                  se ajusten sustancialmente a la funcionalidad establecida en
                  la Documentación, la única y exclusiva obligación de Loadsmart
                  será realizar esfuerzos comercialmente razonables para
                  corregir dicha falta de conformidad o, a la entera discreción
                  de Loadsmart, si dicho remedio resulta impracticable, el
                  Cliente podrá dar por terminado el presente Contrato de
                  conformidad con la Sección 9.2. La garantía establecida en la
                  presente Sección 8.1.1 no será aplicable: (i) si el Cliente
                  presenta una reclamación por falta de conformidad después de
                  treinta (30) días contados a partir de la fecha en que el
                  Cliente haya advertido por primera vez dicha falta de
                  conformidad; (ii) si la falta de conformidad fue causada por
                  un uso indebido, modificaciones no autorizadas o hardware,
                  software o servicios de terceros; o (iii) si los Servicios de
                  Suscripción se ofrecen sin costo, a modo de prueba o para
                  fines de evaluación.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.2.</TitleH4>
                  Loadsmart declara y garantiza que los Servicios serán
                  prestados con calidad profesional, de conformidad con los
                  estándares y prácticas generalmente aceptados en la industria.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.3.</TitleH4>
                  Loadsmart cumplirá en todo momento con todas las leyes, reglas
                  y reglamentos aplicables, incluyendo las leyes de privacidad
                  de datos, así como con los términos del presente Contrato
                  durante la prestación de los Servicios por parte de Loadsmart.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.1.4.</TitleH4>
                  En caso de que Loadsmart utilice o licencie Propiedad
                  Intelectual propiedad de terceros en la ejecución o prestación
                  de los Servicios, Loadsmart declara y garantiza que ha
                  obtenido todas las licencias y autorizaciones necesarias para
                  el uso válido de dicha Propiedad Intelectual de terceros en
                  relación con los Servicios.
                </Paragraph>
              </li>
            </BulltetList>
            <Paragraph>
              <TitleH3>8.2. Declaraciones y Garantías del Cliente.</TitleH3>
              El Cliente declara y garantiza lo siguiente respecto de su uso de
              los Servicios y la provisión de los Datos del Cliente:
            </Paragraph>
            <BulltetList>
              <li>
                <Paragraph>
                  <TitleH4>8.2.1.</TitleH4>
                  El Cliente cuenta con las licencias, derechos, consentimientos
                  y autorizaciones necesarias para utilizar los Datos del
                  Cliente y para permitir que sus Usuarios Autorizados y
                  Loadsmart utilicen y distribuyan los Datos del Cliente en la
                  medida necesaria para prestar y hacer uso de los Servicios.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.2.</TitleH4>
                  Los Datos del Cliente, así como el uso de los mismos conforme
                  a lo previsto en el presente, no infringen ni infringirán, ni
                  violan ni violarán, ni implican ni implicarán una apropiación
                  indebida de ley aplicable alguna ni de derecho alguno de
                  terceros, incluyendo derechos de autor, marcas, patentes,
                  secretos industriales, derechos morales, derechos de
                  privacidad, derechos de publicidad, derechos contractuales o
                  cualquier otro derecho de Propiedad Intelectual o de carácter
                  propietario.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.3.</TitleH4>
                  El Cliente cumplirá en todo momento con todas las leyes,
                  reglas y reglamentos aplicables, incluyendo las leyes de
                  privacidad de datos, así como con los términos del presente
                  Contrato durante el uso de los Servicios.
                </Paragraph>
              </li>
              <li>
                <Paragraph>
                  <TitleH4>8.2.4.</TitleH4>
                  El Cliente no incurrirá en conducta alguna que pueda provocar
                  que un virus u otro código, archivo o programa informático
                  interrumpa, destruya o limite la funcionalidad de los
                  Servicios de Suscripción y/o de cualquier hardware o equipo
                  tecnológico relacionado, ni permitirá de cualquier otra forma
                  el acceso o uso no autorizado de los Servicios de Suscripción.
                </Paragraph>
              </li>
            </BulltetList>

            <Paragraph>
              <TitleH3>8.3. Uso del Cliente y Datos.</TitleH3> Loadsmart no
              asumirá responsabilidad alguna por reclamaciones, pérdidas o daños
              causados por errores u omisiones en cualquier información
              proporcionada por el Cliente o sus Usuarios Autorizados a
              Loadsmart en relación con los Servicios. Salvo que se establezca
              expresamente lo contrario en el presente, Loadsmart excluye
              expresamente cualquier y toda responsabilidad en relación con los
              Datos del Cliente. Loadsmart no tiene obligación alguna de editar
              ni controlar los Datos del Cliente, incluyendo los Datos del
              Cliente que el Cliente introduzca en los Servicios de Suscripción.
              Loadsmart podrá, en cualquier momento y sin previo aviso, eliminar
              cualesquiera Datos del Cliente que infrinjan el presente Contrato
              o la legislación aplicable, o que vulneren los derechos de un
              tercero o de Loadsmart.
            </Paragraph>
            <Paragraph>
              <TitleH3>8.4. Exclusión General de Garantías.</TitleH3> SALVO POR
              LAS GARANTÍAS ESTABLECIDAS EN EL PRESENTE CONTRATO, LOS SERVICIOS
              SE PROPORCIONAN “TAL CUAL” Y LOADSMART EXCLUYE EXPRESAMENTE TODAS
              LAS GARANTÍAS DE CUALQUIER TIPO RELACIONADAS CON LOS SERVICIOS
              PRESTADOS EN VIRTUD DEL PRESENTE, YA SEAN EXPRESAS O IMPLÍCITAS,
              INCLUYENDO, DE MANERA ENUNCIATIVA MAS NO LIMITATIVA, LAS GARANTÍAS
              IMPLÍCITAS DE COMERCIABILIDAD, TITULARIDAD, APTITUD PARA UN FIN
              PARTICULAR Y NO INFRACCIÓN.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                8.5. Exclusión Relativa a Inteligencia Artificial.
              </TitleH3>{' '}
              CIERTAS FUNCIONALIDADES Y CARACTERÍSTICAS DE LOS SERVICIOS DE
              SUSCRIPCIÓN SE ENCUENTRAN IMPULSADAS POR INTELIGENCIA ARTIFICIAL
              DE TERCEROS Y LOADSMART NO OTORGA, Y POR EL PRESENTE EXCLUYE,
              CUALESQUIERA Y TODAS LAS DECLARACIONES O GARANTÍAS, YA SEAN
              EXPRESAS O IMPLÍCITAS, INCLUYENDO GARANTÍAS DE TITULARIDAD,
              COMERCIABILIDAD, APTITUD PARA UN FIN PARTICULAR, EXACTITUD,
              INTEGRIDAD Y NO INFRACCIÓN DE DERECHOS DE TERCEROS, RESPECTO DE
              CUALQUIER INFORMACIÓN, RECOMENDACIONES, RESPUESTAS, ANÁLISIS U
              OTROS DATOS PROPORCIONADOS POR DICHAS FUNCIONALIDADES O
              CARACTERÍSTICAS A CADA USUARIO AUTORIZADO.
            </Paragraph>
          </div>
          <div>
            <TitleH2>9. PLAZO Y TERMINACIÓN</TitleH2>
            <Paragraph>
              <TitleH3>9.1. Plazo.</TitleH3>
              El presente Contrato surtirá efectos a partir de la Fecha de
              Entrada en Vigor y permanecerá en pleno vigor y efecto: (a)
              respecto de cada Formulario de Pedido, hasta la conclusión del
              Plazo de Suscripción; y (b) respecto de cada Declaración de
              Trabajo, hasta la conclusión del plazo aplicable establecido en la
              misma. En el caso de los Servicios de Suscripción, el Plazo de
              Suscripción se renovará automáticamente por periodos sucesivos de
              doce (12) meses una vez concluido el Plazo de Suscripción inicial,
              salvo que cualquiera de las partes notifique por escrito a la otra
              su intención de dar por terminado el mismo con al menos treinta
              (30) días de anticipación a la expiración del Plazo de Suscripción
              vigente en ese momento.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.2. Terminación por Incumplimiento.</TitleH3>. En caso
              de que cualquiera de las partes incurra en un incumplimiento
              sustancial de sus obligaciones conforme al presente Contrato o a
              cualquier Formulario de Pedido o Declaración de Trabajo
              (incluyendo las obligaciones de pago), la parte cumplida podrá
              notificar por escrito a la parte incumplida especificando la
              naturaleza del incumplimiento, y si dicho incumplimiento no es
              subsanado dentro de los treinta (30) días siguientes a la
              recepción de dicha notificación, la parte cumplida tendrá el
              derecho de dar por terminado de manera inmediata el presente
              Contrato o el Formulario de Pedido o la Declaración de Trabajo
              mediante notificación escrita. Si el incumplimiento se refiere
              exclusivamente a un Formulario de Pedido o Declaración de Trabajo,
              únicamente dicho Formulario de Pedido o Declaración de Trabajo
              podrá darse por terminado de conformidad con los términos aquí
              establecidos, y todos los demás Formularios de Pedido y
              Declaraciones de Trabajo, así como el presente Contrato,
              permanecerán en pleno vigor y efecto. En caso de que el Cliente dé
              por terminado un Formulario de Pedido de conformidad con la
              presente Sección 9.2, el Cliente tendrá derecho a un reembolso
              prorrateado de cualesquiera Honorarios pagados por adelantado
              correspondientes al periodo restante del Plazo de Suscripción
              contado a partir de la fecha efectiva de terminación.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.3. Terminación por Insolvencia.</TitleH3>
              No obstante cualquier disposición en contrario en el presente,
              cualquiera de las partes podrá dar por terminado el presente
              Contrato de manera inmediata mediante notificación escrita a la
              otra parte en caso de que dicha otra parte se declare insolvente,
              realice una cesión en beneficio de acreedores, cese operaciones, o
              si se inicia por o en contra de dicha parte cualquier
              procedimiento de quiebra, reorganización, convenio, insolvencia,
              liquidación u otro procedimiento conforme a cualquier ley
              concursal o de alivio a deudores y dicho procedimiento no sea
              sobreseído dentro de los sesenta (60) días siguientes.
            </Paragraph>
            <Paragraph>
              <TitleH3>
                9.4. Derechos y Obligaciones tras la Expiración o Terminación.
              </TitleH3>
              A la expiración o terminación del presente Contrato, (i) el
              derecho del Cliente y de sus Usuarios Autorizados para acceder y
              utilizar los Servicios de Suscripción terminará de manera
              inmediata; (ii) el Cliente y sus Usuarios Autorizados cesarán de
              inmediato todo uso de los Servicios de Suscripción; (iii) el
              Cliente deberá eliminar o devolver, y no volver a utilizar,
              cualesquiera materiales, Información Confidencial de Loadsmart,
              Documentación, Propiedad Intelectual de Loadsmart, nombres de
              usuario, contraseñas u otros elementos (y todas las copias de los
              mismos) obtenidos en relación con los Servicios; y (iv) el Cliente
              no tendrá acceso ulterior a cualesquiera Datos del Cliente
              introducidos en los Servicios de Suscripción.
            </Paragraph>
            <Paragraph>
              <TitleH3>9.5. Supervivencia.</TitleH3>A la terminación, cualquier
              disposición que, por su naturaleza o por sus términos expresos,
              deba subsistir, subsistirá, incluyendo, de manera enunciativa mas
              no limitativa, las Secciones 5, 6, 7, 10, 11 y 12.
            </Paragraph>
          </div>
          <div>
            <TitleH2>10. INDEMNIZACIÓN</TitleH2>
            <Paragraph>
              <TitleH3>10.1. Indemnización por parte del Cliente.</TitleH3>
              El Cliente deberá indemnizar, defender y mantener en paz y a salvo
              a Loadsmart, sus Afiliadas y subsidiarias, así como a sus
              respectivos funcionarios, consejeros y empleados, frente a
              cualesquiera responsabilidades, pérdidas, daños y gastos,
              incluyendo costas judiciales y honorarios razonables de abogados,
              relacionados con cualquier reclamación formulada por un tercero,
              en la medida y proporción en que deriven de: (i) el uso por parte
              del Cliente o de sus Usuarios Autorizados, o de cualquier persona
              a quien el Cliente haya otorgado acceso para utilizar, los
              Servicios de una manera que viole la legislación aplicable, los
              términos del presente Contrato o los términos del DPA (en su
              caso); (ii) la alegación de que cualesquiera Datos del Cliente
              violan derechos de privacidad, derechos de Propiedad Intelectual u
              otros derechos de un tercero; o (iii) el incumplimiento sustancial
              por parte del Cliente del presente Contrato. Las obligaciones del
              Cliente conforme a la presente Sección 10.1 estarán condicionadas
              a que Loadsmart notifique oportunamente por escrito al Cliente
              sobre dicha reclamación.
            </Paragraph>
            <Paragraph>
              <TitleH3>10.2. Indemnización por parte de Loadsmart.</TitleH3>.
              Loadsmart deberá indemnizar, defender y mantener en paz y a salvo
              al Cliente, así como a sus funcionarios, consejeros y empleados,
              frente a cualesquiera responsabilidades, pérdidas, daños y gastos,
              incluyendo costas judiciales y honorarios razonables de abogados,
              relacionados con cualquier reclamación de un tercero, en la medida
              y proporción en que deriven de: (i) la infracción o apropiación
              indebida de derechos de Propiedad Intelectual de un tercero como
              resultado del uso autorizado por parte del Cliente de un
              Entregable o de los Servicios de Suscripción; (ii) la violación
              por parte de Loadsmart de la legislación aplicable; o (iii) el
              incumplimiento sustancial por parte de Loadsmart del presente
              Contrato. Las obligaciones de Loadsmart conforme a la presente
              Sección 10.2 estarán condicionadas a que: (a) el Cliente notifique
              oportunamente por escrito a Loadsmart sobre dicha reclamación; (b)
              el Cliente proporcione cooperación razonable a Loadsmart, a costa
              de Loadsmart, en la defensa y resolución de dicha reclamación; y
              (c) Loadsmart tenga la autoridad exclusiva para defender o
              resolver dicha reclamación. Respecto de las reclamaciones
              descritas en el inciso (i) de la presente, en caso de que la
              capacidad de Loadsmart para prestar los Servicios de Suscripción o
              el uso por parte del Cliente de un Entregable sea prohibida
              judicialmente o, a juicio razonable de Loadsmart, sea probable que
              lo sea, Loadsmart podrá obtener el derecho de continuar prestando
              los Servicios de Suscripción o permitir el uso por parte del
              Cliente del Entregable aplicable, sustituir o modificar los
              Servicios de Suscripción o el Entregable aplicable de manera que
              dejen de infringir, o, si dichos remedios no resultan
              comercialmente viables, dar por terminado el presente Contrato sin
              responsabilidad alguna frente al Cliente y otorgar un reembolso
              prorrateado de cualesquiera Honorarios pagados por adelantado y no
              utilizados al momento de dicha terminación. Lo anterior constituye
              la totalidad de las obligaciones de Loadsmart respecto de
              cualquier alegación o infracción real o apropiación indebida de
              derechos de Propiedad Intelectual derivada de los Servicios de
              Suscripción o de un Entregable. Loadsmart no tendrá
              responsabilidad ni obligación alguna conforme a la presente
              Sección 10.2 por reclamaciones de infracción causadas total o
              parcialmente por: (x) instrucciones, información, diseños u otros
              materiales proporcionados por el Cliente a Loadsmart como parte de
              los Servicios; (y) modificaciones de los Servicios de Suscripción
              o de un Entregable realizadas por cualquier parte distinta de
              Loadsmart sin el consentimiento expreso y por escrito de
              Loadsmart; o (z) la combinación, operación o uso de los Servicios
              de Suscripción o de un Entregable con otros productos, datos o
              servicios cuando los Servicios de Suscripción o el Entregable
              aplicable, por sí solos, no constituyan una infracción. No
              obstante cualquier disposición en contrario en el presente,
              Loadsmart no tendrá obligación ni responsabilidad alguna conforme
              a la presente Sección 10.2 por reclamaciones derivadas de la
              negligencia, dolo o fraude del Cliente.
            </Paragraph>
          </div>
          <div>
            <TitleH2>11. LIMITACIÓN DE RESPONSABILIDAD</TitleH2>
            <Paragraph>
              <TitleH3>11.1. Renuncia a Daños.</TitleH3>
              SALVO EN EL CASO DE UNA RECLAMACIÓN EXCLUIDA, EN NINGÚN CASO
              NINGUNA DE LAS PARTES SERÁ RESPONSABLE FRENTE A LA OTRA POR DAÑOS
              INDIRECTOS, INCIDENTALES, ESPECIALES, EJEMPLARES, POR CONFIANZA,
              PUNITIVOS O CONSECUENCIALES, INCLUYENDO PÉRDIDA DE INGRESOS,
              DATOS, UTILIDADES, RENTAS O INTERRUPCIÓN DEL NEGOCIO, O COSTOS DE
              SERVICIOS SUSTITUTOS U OTRAS PÉRDIDAS ECONÓMICAS, YA SEA QUE DICHA
              PARTE HAYA SIDO O NO ADVERTIDA DE LA POSIBILIDAD DE TALES DAÑOS, Y
              SIN IMPORTAR SI CUALQUIER RECLAMACIÓN PARA SU RESARCIMIENTO SE
              BASA EN TEORÍAS DE CONTRATO, GARANTÍA, RESPONSABILIDAD
              EXTRACONTRACTUAL (INCLUYENDO NEGLIGENCIA Y RESPONSABILIDAD
              OBJETIVA) O DE CUALQUIER OTRA ÍNDOLE, Y CADA PARTE POR EL PRESENTE
              LIBERA Y RENUNCIA A CUALESQUIERA RECLAMACIONES EN CONTRA DE LA
              OTRA PARTE RESPECTO DE DICHA RESPONSABILIDAD Y DAÑOS.
            </Paragraph>
            <Paragraph>
              <TitleH3>11.2. Límite de Responsabilidad.</TitleH3>
              En la máxima medida permitida por la ley, en ningún caso la
              responsabilidad total y acumulada de Loadsmart frente al Cliente
              en relación con el presente Contrato por cualesquiera y todas las
              reclamaciones, pérdidas, costos o daños de cualquier naturaleza,
              incluyendo honorarios razonables de abogados, excederá el monto
              total de los Honorarios pagados por el Cliente conforme al
              Formulario de Pedido o la Declaración de Trabajo aplicables
              durante el periodo de doce (12) meses anterior al hecho que haya
              dado origen a la reclamación o acción correspondiente,
              independientemente de la forma o teoría de dicha reclamación o
              acción.
            </Paragraph>
          </div>
          <div>
            <TitleH2>12. GENERALES</TitleH2>
            <Paragraph>
              <TitleH3>12.1. Ley Aplicable; Jurisdicción.</TitleH3>
              El presente Contrato y todas las cuestiones que deriven de o se
              relacionen con el mismo se regirán por las leyes del estado de
              Illinois, sin dar efecto a sus disposiciones sobre conflicto de
              leyes. La jurisdicción exclusiva para cualquier reclamación o
              controversia que derive de o se relacione con el presente Contrato
              corresponderá a los tribunales estatales y federales ubicados en
              el Condado de Cook, Illinois, y cada una de las partes renuncia de
              manera irrevocable e incondicional a la defensa de foro
              inconveniente.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.2. Modificaciones; Renuncia.</TitleH3>
              Salvo que se disponga expresamente lo contrario en el presente,
              este Contrato únicamente podrá ser modificado mediante un
              instrumento escrito firmado por un representante debidamente
              autorizado de cada una de las partes. Ninguna renuncia a
              disposición alguna del presente será válida a menos que conste por
              escrito y esté firmada por la parte que renuncia. El hecho de que
              cualquiera de las partes no exija el cumplimiento de cualquier
              término u obligación del presente Contrato, o la renuncia por
              cualquiera de las partes a cualquier incumplimiento del mismo, no
              impedirá la exigencia posterior de dicho término u obligación ni
              se considerará como una renuncia a cualquier incumplimiento
              posterior.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.3. Modificaciones Unilaterales.</TitleH3>
              No obstante cualquier disposición en contrario contenida en la
              Sección 12.2, de tiempo en tiempo Loadsmart podrá modificar el
              presente Contrato respecto de los Servicios de Suscripción y,
              salvo que Loadsmart indique lo contrario, dichas modificaciones
              surtirán efectos a partir de la fecha que ocurra primero de las
              siguientes: (i) el acceso o uso por parte del Cliente de los
              Servicios de Suscripción con posterioridad a dichas
              modificaciones; (ii) la aceptación por parte del Cliente de los
              términos modificados mediante mecanismo de aceptación electrónica
              (click-through); o (iii) mediante notificación por correo
              electrónico enviada a la dirección designada en el Formulario de
              Pedido aplicable. Para los Formularios de Pedido vigentes con
              anterioridad a dichas modificaciones, el Cliente podrá dar por
              terminado el Formulario de Pedido aplicable dentro de los treinta
              (30) días siguientes a que las modificaciones entren en vigor y
              recibir, como único remedio, un reembolso de los Honorarios
              pagados por adelantado correspondientes al periodo restante del
              Plazo de Suscripción.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.4. Subcontratación.</TitleH3>
              Nada de lo dispuesto en el presente Contrato impedirá que
              Loadsmart utilice los servicios de cualesquiera subcontratistas
              que considere apropiados para el cumplimiento de sus obligaciones
              conforme al presente; siempre que Loadsmart exija a dichos
              subcontratistas el cumplimiento de todos los términos y
              condiciones aplicables del presente Contrato al prestar dichos
              servicios, y Loadsmart permanecerá como principal responsable
              frente al Cliente por la actuación de dichos subcontratistas.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.5. Notificaciones.</TitleH3>
              Cualesquiera notificaciones proporcionadas por Loadsmart conforme
              al presente Contrato se realizarán a la dirección establecida en
              el Formulario de Pedido o la Declaración de Trabajo aplicables.
              Las notificaciones y cualesquiera otras comunicaciones previstas
              en el presente se considerarán recibidas: (i) cuando sean
              efectivamente recibidas, si se entregan de manera personal o por
              mensajería; o (ii) cinco (5) días después de su envío si se
              remiten por correo certificado, con franqueo pagado y acuse de
              recibo solicitado. Las notificaciones dirigidas a Loadsmart
              deberán incluir una copia por correo electrónico a{' '}
              <Link href="mailto:legal@loadsmart.com">Legal@Loadsmart.com</Link>
              .
            </Paragraph>
            <Paragraph>
              <TitleH3>12.6. Divisibilidad.</TitleH3>
              Si alguna disposición del presente Contrato es declarada inválida
              o inaplicable, las disposiciones restantes permanecerán en pleno
              vigor y efecto.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.7. Fuerza Mayor.</TitleH3>
              Ninguna de las partes será responsable conforme al presente por
              cualquier incumplimiento o retraso en el cumplimiento de sus
              obligaciones (salvo por el pago de Honorarios) cuando dicho
              incumplimiento o retraso se deba a acontecimientos fuera del
              control razonable de dicha parte, los cuales podrán incluir, de
              manera enunciativa mas no limitativa, ataques de denegación de
              servicio, ciberataques, huelgas (excepto de sus propios
              empleados), escasez, disturbios, insurrecciones, incendios,
              inundaciones, pandemias, epidemias, tormentas, explosiones, casos
              fortuitos, guerras, actos de terrorismo, acciones gubernamentales,
              condiciones laborales, terremotos, fallas o disminuciones en el
              suministro de energía, telecomunicaciones o redes de datos, y
              escasez de materiales (cada uno, un{' '}
              <strong>“Evento de Fuerza Mayor”</strong>). A la ocurrencia de un
              Evento de Fuerza Mayor, la parte incumplida quedará exenta del
              cumplimiento de las obligaciones afectadas por dicho Evento de
              Fuerza Mayor durante el tiempo que éste subsista, siempre que
              dicha parte realice esfuerzos comercialmente razonables para
              reanudar el cumplimiento.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.8. Cumplimiento Normativo.</TitleH3>
              Cada una de las partes se obliga a cumplir con todas las leyes y
              reglamentos aplicables, incluyendo las leyes de exportación de los
              Estados Unidos de América, en relación con sus actividades
              conforme al presente.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.9. Relación entre las Partes.</TitleH3>
              Nada de lo dispuesto en el presente Contrato se interpretará como
              la creación de una sociedad, empresa conjunta o relación de
              agencia entre las partes. Ninguna de las partes tendrá la facultad
              de obligar a la otra ni de asumir obligaciones en nombre de la
              otra sin el consentimiento previo y por escrito de dicha otra
              parte.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.10. Cesión/Sucesores.</TitleH3>
              Ninguna de las partes podrá ceder o transferir un Formulario de
              Pedido, una Declaración de Trabajo o el presente Contrato, total o
              parcialmente, sin el consentimiento previo y por escrito de la
              otra parte. No obstante lo anterior, Loadsmart podrá ceder o
              transferir libremente el presente Contrato a cualquiera de sus
              Afiliadas o a cualquier adquirente de la totalidad o
              sustancialmente la totalidad de sus activos, o en relación con
              cualquier fusión o consolidación. Cualquier intento de cesión o
              transferencia realizado en contravención de la presente Sección
              será nulo y sin efecto alguno.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.11. Contrato Íntegro.</TitleH3>
              El presente Contrato, junto con el Formulario de Pedido o la
              Declaración de Trabajo aplicables, constituye el acuerdo completo
              y exclusivo entre las partes con respecto a su objeto y sustituye
              cualquier acuerdo o entendimiento previo o contemporáneo, ya sea
              escrito u oral, relacionado con el objeto del presente Contrato.
              El presente Contrato podrá firmarse en ejemplares separados, cada
              uno de los cuales se considerará un original y todos ellos, en
              conjunto, constituirán un solo y mismo contrato. Ninguna
              disposición contenida en órdenes de compra u otros formatos
              comerciales similares utilizados por el Cliente sustituirá los
              términos y condiciones del presente Contrato, y cualquier
              documento de dicha naturaleza relacionado con el presente será
              únicamente para fines administrativos y no tendrá efecto legal
              alguno respecto de los Servicios. Este Contrato se celebra en
              ejemplares de igual tenor en inglés y español para ambas Partes.
              En caso de discrepancia, prevalecerá la versión en idioma inglés.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.12. Medidas Cautelares.</TitleH3>
              Cada una de las partes reconoce que un incumplimiento por parte de
              la otra de los derechos de confidencialidad establecidos en la
              Sección 7.1 o de los derechos de Propiedad Intelectual
              establecidos en la Sección 6 del presente Contrato puede causar a
              la parte cumplida daños irreparables para los cuales la
              indemnización por daños y perjuicios no constituiría una
              compensación adecuada. En consecuencia, la parte cumplida podrá
              solicitar la emisión de una orden judicial que prohíba cualquier
              incumplimiento o amenaza de incumplimiento de dichas
              disposiciones, además de cualesquiera otros recursos a los que
              tenga derecho conforme a derecho o en equidad.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.13. Ausencia de Beneficiarios de Terceros.</TitleH3>
              El presente Contrato se celebra exclusivamente en beneficio de las
              partes firmantes y no tiene por objeto beneficiar a ningún
              tercero. Únicamente las partes del presente podrán exigir el
              cumplimiento del mismo.
            </Paragraph>
            <Paragraph>
              <TitleH3>12.14. Orden de Prelación.</TitleH3>
              En caso de conflicto entre los términos de un Formulario de Pedido
              o una Declaración de Trabajo y el presente Contrato, prevalecerán
              los términos del Formulario de Pedido o de la Declaración de
              Trabajo, según corresponda.
            </Paragraph>
          </div>
        </Layout>
      </>
      <Footer />
    </>
  );
};

export default SubscriptionAndProfessionalServicesAgreementES;
export { SubscriptionAndProfessionalServicesAgreementES };
